var render = function render(){var _vm=this,_c=_vm._self._c;return _c('SimpleModuleDashboard',{attrs:{"module-id":_vm.Modules.PROYECTOS,"profile-id":_vm.Profiles.PERSONAL,"actions":_vm.dashboardActions,"include-php-custom":"","widget-groups":_vm.widgetGroups,"widget-tabs":_vm.widgetTabs,"tabs-storage-key":"tabs_view_dashboard_projects","tabs-legacy-map":_vm.tabsLegacyMap}})
}
var staticRenderFns = []

export { render, staticRenderFns }